/*
Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Redirect } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
//import { Button, Input, Form, Label } from 'semantic-ui-react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import {Auth} from '@aws-amplify/auth';

const styles = theme => ({
  container: {
    display: 'flex',
    width:'100%',
    height:'100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textFieldContainer: {
    width: 400,
    height: 300,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginLeft: theme.spacing.unit*3,
    marginRight: theme.spacing.unit*3,
    width: 346,
  },
  validationLabels: {
    marginLeft: theme.spacing.unit*3,
  },
  buttonsContainer: {
    display: 'flex',
    paddingTop: '2em',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: 400,
  },
});

class Forget extends Component {

    state = {
        username: '',
        code: '',
        invalidUserNameMessage: '',
        invalidCodeMessage: '',
        resetSuccess: false,
        enterReset: false,
        enableResend: false,
        enableSend: true,
        enterInputPassword: false,
        password: '',
        passwordMatch: '',
        invalidPasswordMessage: '',
        submitPassword: false,
        invalidCodeOrPasswordMessage: ''
    }

    handlePasswordMatchChange = (e) => {
        e.preventDefault();
        const value = e.target.value;
        const message = this.checkPasswordMatch(value, this.state.password) ? '' : 'Password does not match';
        this.setState(() => {
            return {
                passwordMatch: value,
                invalidPasswordMessage: message,
                invalidCodeOrPasswordMessage: ''
            }
        });
    }

    checkPasswordMatch = (password, passwordMatch) => {
        return password === passwordMatch;
    }

    sendVerificationCode = async (e) => {
        e.preventDefault();
        const username = this.state.username;
        if (!username) {
            this.setState(() => {
                return {
                    invalidCodeOrPasswordMessage: 'Please input valid username'
                }
            })
        }
        Auth.forgotPassword(username)
            .then(data => {
                if (this.state.enableSend) {
                    this.setState(() => {
                        return {
                            enableSend: false
                        }
                    });
                    this.countDownResendVerificationCode();
                }
                if (this.state.enableResend) {
                    this.setState(() => {
                        return {
                            enableResend: false
                        }
                    })
                    this.countDownResendVerificationCode();
                }
                this.setState({ enterReset: true});
            })
            .catch(err => console.log(err));
    }

    resendVerificationCode = (e) => {
        e.preventDefault();
        this.state.userObject.resendConfirmationCode((err, result) => {
            if (err) {
                this.checkUsername(err.toString());
                console.log(err.toString());
                return;
            }
            this.countDownResendVerificationCode();
        });
    }

    enterInputPassword = (e) => {
        e.preventDefault();
        const code = this.state.code;
        if (!code) {
            this.setState(() => {
                return {
                    invalidCodeOrPasswordMessage: 'Verification code can not be empty'
                }
            });
            return;
        }
        this.setState(() => {
            return {
                enterInputPassword: true,
                enterReset: false,
                invalidCodeOrPasswordMessage: ''
            }
        });
    }

    handlePasswordReset = async (e) => {
        e.preventDefault();
        const message = this.state.invalidPasswordMessage;
        if (message) {
            return;
        }
        const username = this.state.username;
        const verificationCode = this.state.code;
        const newPassword = this.state.password;
        Auth.forgotPasswordSubmit(username, verificationCode, newPassword)
            .then(
                this.setState(() => {
                    return {
                        resetSuccess: true
                    }
                })
            )
            .catch(err => console.log(err))
    }

    countDownResendVerificationCode = () => {
        let counter = 10;
        let seconds = setInterval(() => {
            if (counter === 0) {
                clearInterval(seconds);
                this.setState(() => {
                    return {
                        enableResend: true
                    }
                });
            }
            counter--;
        }, 1000);
    }

    render() {
        const {
            invalidPasswordMessage,
            invalidCodeOrPasswordMessage,
            resetSuccess,
            enableSend,
            enableResend,
            enterReset,
            enterInputPassword } = this.state;

        const { classes } = this.props;

        return (
            <CSSTransitionGroup
                transitionName="sample-app"
                transitionEnterTimeout={500}
                transitionAppearTimeout={500}
                transitionLeaveTimeout={300}
                transitionAppear={true}
                transitionEnter={true}
                transitionLeave={true}>
            <div className={classes.container}>
                { !resetSuccess && (

                <div>
                    <Paper className={classes.textFieldContainer}>
                      <div className={classes.logoContainer}>
                        <img src='./hipkar-logo-text.png' className={classes.hipkarLogo}  alt="hipkar - get the best deal on a car lease" />
                      </div>
                        { !enterReset && !enterInputPassword && (
                          <TextField
                            id="username"
                            label="Username"
                            className={classes.textField}
                            onChange = {(event) => this.setState({username:event.target.value, invalidCodeOrPasswordMessage: ''})}
                            margin="normal"
                          />)}
                        { invalidCodeOrPasswordMessage && <Typography className={classes.validationLabels} variant="body1" color="error">{ invalidCodeOrPasswordMessage } </Typography> }
                        { enterReset && !enterInputPassword && (
                          <TextField
                            id="code"
                            label="Verification Code"
                            className={classes.textField}
                            onChange = {(event) => this.setState({code:event.target.value, invalidCodeOrPasswordMessage: '', invalidCodeMessage: ''})}
                            margin="normal"
                          />
                        )}
                        { invalidCodeOrPasswordMessage && <Typography className={classes.validationLabels} variant="body1" color="error">{ invalidCodeOrPasswordMessage } </Typography> }
                        { enterInputPassword && (
                          <TextField
                            id="password"
                            type="password"
                            label="Password"
                            className={classes.textField}
                            onChange = {(event) => this.setState({password:event.target.value, invalidPasswordMessage: '', invalidCodeOrPasswordMessage: ''})}
                            margin="normal"
                          />)}
                          { invalidPasswordMessage && <Typography className={classes.validationLabels} variant="body1" color="error">Password does not match</Typography>}
                          { invalidCodeOrPasswordMessage && <Typography className={classes.validationLabels} variant="body1" color="error">{ invalidCodeOrPasswordMessage }</Typography> }

                        <div className={classes.buttonsContainer}>
                            { enterReset && <Button variant="raised" color="primary"  onClick={this.enterInputPassword} style={{marginRight: 1 + 'em'}}>Reset password</Button> }
                            { enterInputPassword && <Button color="primary" onClick={this.handlePasswordReset} style={{marginRight: 2 + 'em'}}>Submit</Button> }
                            { enableSend && <Button color="primary" variant="raised" onClick={this.sendVerificationCode} style={{marginRight: 2 + 'em'}}>Send Verficiation Code</Button> }
                            { !enableResend && !enableSend && <Button disabled style={{marginRight: 2 + 'em'}}>Waiting to resend</Button> }
                            { enableResend && enterReset && <Button onClick={ this.sendVerificationCode } style={{marginRight: 2 + 'em'}}>Resend it!</Button> }
                        </div>
                    </Paper>
                </div>
                )}
                { resetSuccess && <Redirect to="/login" /> }
            </div>
            </CSSTransitionGroup>
        );
    }
}

Forget.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Forget);



// WEBPACK FOOTER //
// ./src/Auth/Forget.jsx